(function (){
    'use strict';

    angular
        .module('services')
        .service('TswAppService', TswAppService);

    TswAppService.$inject = ['$http', 'API_BASE'];

    function TswAppService ($http, API_BASE) {
        var service = this;

        service.getPlansAcquired = getPlansAcquired;
        service.getInstitutions = getInstitutions;
        service.getInstitutionsNames = getInstitutionsNames;
        service.getInstitutionsCountries = getInstitutionsCountries;
       
        function getPlansAcquired(query)
        {
            return $http.get(API_BASE + '/tsw-app/plans-acquired', {params:query})
                .then(function(response) {
                    return response.data;
                });
        }

        function getInstitutions(query)
        {
            return $http.get(API_BASE + '/tsw-app/institutions', {params:query})
                .then(function(response) {
                    return response.data;
                });
        }

        function getInstitutionsNames(query)
        {
            return $http.get(API_BASE + '/tsw-app/institutions-names', {params:query})
                .then(function(response) {
                    return response.data;
                });
        }

        function getInstitutionsCountries(query)
        {
            return $http.get(API_BASE + '/tsw-app/institutions-countries', {params:query})
                .then(function(response) {
                    return response.data;
                });
        }
    }
})();